export const AppMenu = [
  {
    title: "main",
    description:
      "누구나 필요한 정보와 지식을 얻고\n더 넓은 세상으로 나아가며,\n함께 사회 변화를 만들어 가길 바랍니다.",
    is_active: false,
    paths: ["/app/main"],
  },
  {
    title: "Wezon",
    description:
      "누구나 필요한 정보와 지식을 얻고\n더 넓은 세상으로 나아가며,\n함께 사회 변화를 만들어 가길 바랍니다.",
    is_active: true,
    paths: ["/app/pages/wezon", "/app/pages/history", "/app/pages/directions"],
    children: [
      {
        title: "소개",
        paths: ["/app/pages/wezon"],
      },
      {
        title: "연혁",
        paths: ["/app/pages/history"],
      },
      {
        title: "오시는 길",
        paths: ["/app/pages/directions"],
      },
    ],
  },
  {
    title: "Service",
    description:
      "길 위의 작은 배려를 더하며,\n모두의 이동이 자유로운 세상을 꿈꿉니다.",
    is_active: true,
    paths: ["/app/pages/wemap", "/app/pages/weslo", "/app/pages/webus"],
    children: [
      {
        title: "위맵",
        paths: ["/app/pages/wemap"],
      },
      {
        title: "위슬로",
        paths: ["/app/pages/weslo"],
      },
      {
        title: "위버스",
        paths: ["/app/pages/webus"],
      },
    ],
  },
  {
    title: "Data",
    description:
      "사람들의 발걸음에서 모인 작은 기록이\n더 자유로운 이동의 미래를 만듭니다.",
    is_active: true,
    paths: ["/app/pages/movement_data", "/app/pages/ai_data"],
    children: [
      {
        title: "Movement Data",
        paths: ["/app/pages/movement_data"],
      },
      {
        title: "AI Data",
        paths: ["/app/pages/ai_data"],
      },
    ],
  },
  {
    title: "IT",
    description:
      "다양한 아이디어와\n사회적 가치를 담은 기술이 모여,\n모두를 위한 새로운 플랫폼을 만듭니다.",
    is_active: true,
    paths: ["/app/pages/solution", "/app/pages/web", "/app/pages/inquiry"],
    children: [
      {
        title: "Solution",
        paths: ["/app/pages/solution"],
      },
      {
        title: "Web",
        paths: ["/app/pages/web"],
      },
      {
        title: "제작문의",
        paths: ["/app/pages/inquiry"],
      },
    ],
  },
  {
    title: "PR",
    description:
      "우리 활동과 소식이 모여\n함께 만드는 더 나은 변화를 전합니다.",
    is_active: true,
    paths: ["/app/news", "/app/news/:id", "/app/media", "/app/media/:id"],
    children: [
      {
        title: "활동소식",
        paths: ["/app/news", "/app/news/:id"],
      },
      {
        title: "언론보도",
        paths: ["/app/media", "/app/media/:id"],
      },
    ],
  },
];
